import Vue from 'vue';
import ElementUI from 'element-ui';
import axios from '@/utils/request';

import App from './App.vue';
import router from './router';
import store from './store';

import sysConfig from '@/api/sysConfig';

import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/reset.css';
import '@/assets/style/base.scss';

import './mxGraphConf';
import 'animate.css';
import './VeeValidateConf/index';

import './assets/iconfont/iconfont.css';

Vue.config.productionTip = false;

Vue.use(ElementUI);

const token = localStorage.getItem('userToken');
const lastOnBoardTime = parseInt(localStorage.getItem('lastOnBoardTime'));

if (lastOnBoardTime && Date.now() - lastOnBoardTime > 3600000) {
  // 超时删除token
  store.dispatch('authLogout');
}
localStorage.setItem("lastOnBoardTime", new Date().getTime().toString());

// 恢复vuex数据
const resetVuex = () => {
  const userProfile = JSON.parse(localStorage.getItem('userProfile')) || {};
  const workUnits = JSON.parse(localStorage.getItem('workUnits')) || [];
  const currentWorkUnitId = localStorage.getItem('currentWorkUnitId') || '';

  store.commit('userRequest', userProfile);
  store.commit('getWorkUnits', workUnits);
  store.commit('authSuccess', token);
  if (currentWorkUnitId) {
    store.commit('changeStationID', currentWorkUnitId);
  }
};

if (token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  resetVuex();
} else {
  // 之前未登录过，获取默认workUnitId，进入大屏左上角下拉菜单显示默认workUnitId
  sysConfig.getConfigWithoutToken({ code: "defaultWorkUnitId" }).then(res => {
    if (res.code == 200 && res.data.records.length > 0) {
      let defaultWorkUnitId = parseInt(res.data.records[0].value);
      store.commit('changeStationID', defaultWorkUnitId);
    }
  });
}

Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
